/**
 * Bot Model Types
 *
 * This file imports the generated Zod schemas for bot data models and infers TypeScript types.
 *
 * The Zod schemas are generated from JSON Schema, which is generated from Pydantic models.
 * See apps/live-agent-server/models.py for the source of truth.
 */
import { organizationContextSchema } from "./generated/organization-context.generated.js";
import { offeringContextSchema } from "./generated/offering-context.generated.js";
import { contextDataSchema } from "./generated/context-data.generated.js";
import { sessionDataSchema } from "./generated/session-data.generated.js";
import { sessionMessageSchema } from "./generated/session-message.generated.js";
import { sectionProgressSchema } from "./generated/section-progress.generated.js";
import { botBodyDataSchema } from "./generated/bot-body-data.generated.js";
import { slotSchema } from "./generated/slot.generated.js";
// Export individual schemas
export { organizationContextSchema, offeringContextSchema, contextDataSchema, sessionDataSchema, sessionMessageSchema, sectionProgressSchema, botBodyDataSchema, slotSchema, };
